import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'me-grid-column',
  styleUrl: 'me-grid-column.scss',
  shadow: false,
})
export class MeGridColumn {

  @Prop() columns?: string;
  @Prop() start?: string;
  @Prop() row?: number;

  render() {
    const classList = [
      'me-grid-column',
      ...this.parsedClassList(this.columns, 'g-col-'),
      ...this.parsedClassList(this.start, 'g-start-'),
    ].filter(c => !!c).join(' ');

    return (
      <Host class={classList} style={this.row ? {gridRow: `${this.row}`} : {}}>
        <slot></slot>
      </Host>
    );
  }

  private parsedClassList(classList: string, prefix: string): string[] {
    return (classList ?? '')
      .split(/\s+/)
      .filter(c => !!c)
      .map(c => `${prefix}${c}`);
  }

}
